import { useRef, useEffect } from "react";

// Hook to create AbortController per logical fetch and auto-abort on unmount or
// when creating a new controller. Also supports an optional timeout that will
// abort the request after `timeoutMs` milliseconds.
export default function useCancelableFetch(timeoutMs = 30000) {
  const controllerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (controllerRef.current) {
        try {
          controllerRef.current.abort();
        } catch (e) {
          // ignore
        }
        if (controllerRef.current._timeoutId)
          clearTimeout(controllerRef.current._timeoutId);
        controllerRef.current = null;
      }
    };
  }, []);

  const createController = (customTimeoutMs) => {
    // abort previous
    if (controllerRef.current) {
      try {
        controllerRef.current.abort();
      } catch (e) {}
      if (controllerRef.current._timeoutId)
        clearTimeout(controllerRef.current._timeoutId);
    }

    const controller = new AbortController();
    const t = typeof customTimeoutMs === "number" ? customTimeoutMs : timeoutMs;
    if (t && t > 0) {
      controller._timeoutId = setTimeout(() => {
        try {
          controller.abort();
        } catch (e) {}
      }, t);
    }
    controllerRef.current = controller;
    return controller;
  };

  const abort = () => {
    if (controllerRef.current) {
      try {
        controllerRef.current.abort();
      } catch (e) {}
      if (controllerRef.current._timeoutId)
        clearTimeout(controllerRef.current._timeoutId);
      controllerRef.current = null;
    }
  };

  return { createController, abort };
}
